import { useState } from "react";
import {
  Tabs,
  Typography,
  Layout,
  Col,
  Row,
  Image,
} from "antd";

import "antd/dist/reset.css";
import "../containers/customLayout.css";
import { isAuthenticated } from "@seims/shared/src/security";
import moment from "moment";
import { useCookies } from "react-cookie";


import { CookieConsentView } from "./CookieConsentView";
import { useNavigate, useParams } from "react-router-dom";
import FAQ from "./FAQ";
import { PrivacyStatment } from "@seims/shared";

export const PrivacyPolicyView = ({ show }) => {
  const [selectedTab, setSelectedTab] = useState("Privacy Policy");
  const [tabContent, setTabContent] = useState("");
  const { Title } = Typography;
  const { Header, Content, Footer } = Layout;
  const params = useParams();
  const navigate = useNavigate();

  const defaultDate = moment().format("YYYY-MM-DD");
  const [closingDate, setClosingDate] = useState(defaultDate);

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [cookies] = useCookies(["cookieConsent"]);

  // let path1 = '/login/:key/:isanon';
  let path1 = "/login";

  const handleCancel = () => {};

  const onTabChange = (selected) => {
    if (selected === "popiact") {
      setSelectedTab("POPI ACT Overview");
    } else if (selected === "privacypolicy") {
      setSelectedTab("Privacy Policy");
    } else if (selected === "terms") {
      setSelectedTab("Terms of Use");
    } else if (selected === "technology") {
      setSelectedTab("Technologies");
    }
    else {
      setSelectedTab("FAQ");

    }
  };
  const AcceptChanges = () => {};

  /// Design motivated by Google Policies: https://policies.google.com/technologies/cookies?hl=en-US

  const tabList = [
    // {
    //   key: "popiact",
    //   label: "POPI ACT Overview",
    // },
    {
      key: "privacypolicy",
      label: "Privacy Policy",
    },
    // {
    //   key: "terms",
    //   label: "Terms of Use",
    // },
    // {
    //   key: "technology",
    //   label: "Technologies",
    // },
    {
      key: "faq",
      label: "FAQ",
    },
  ];

  return (
    <>
      <Layout className="site-layout">
        {isAuthenticated && (
          <Header>
            <div>
              <Row>
                <Col xs={8} md={8}>
                  <div>
                    <Image
                      style={{ paddingRight: "10px" }}
                      className="dst-logo"
                      src={require("../assets/DST-logo.png")}
                      alt="National Youth Service (NYS) DSTI logo"
                    />
                  </div>
                </Col>
                <Col className="center-align" xs={8} md={8}>
                  <div>
                    <Image
                      className="nys-logo"
                      src={require("../assets/NYS-logo-without-background.png")}
                      alt="National Youth Service (NYS) logo"
                    />
                  </div>
                </Col>
                {/* <Col span={6}>
              <PageHeader title="Home" />
            </Col> */}
                <Col xs={8} className="admin-container-landing">
                  {/* <RenderAuthenticated> */}
                  <Image
                    className="user-logo"
                    style={{ height: "50px" }}
                    src={require("../assets/user.png")}
                    alt="National Youth Service (NYS) user"
                  />

                  <a
                    style={{ fontSize: "18px", color: "rgba(0, 0, 0, 0.85)" }}
                    onClick={() => navigate(path1)}
                  >
                    Login
                  </a>

                  {/* </RenderAuthenticated> */}
                </Col>
              </Row>
            </div>

            <div />
          </Header>
        )}

        <Content>
          {/* <Breadcrumb style={{ margin: "16px 0" }} /> */}
          <Row style={{ backgroundColor: "#fff" }}>
            <Tabs
              className=""
              type="card"
              onChange={onTabChange}
              items={tabList}
              key="1"
            />
            <div className="space">
              <br />
              {/* <h1 className="center-align">{"Privacy & Terms"}</h1> */}
              {/* <p className="sub-title center-align">{selectedTab}</p> */}
              <br />

              {selectedTab === "Privacy Policy" ?
                <div className="" style={{ paddingLeft: 10 }}>
                  <PrivacyStatment /></div> : <FAQ />}
            </div>

          </Row>

          <Row style={{ backgroundColor: "#fff", paddingBottom: 30 }}>
            <Col xs={24}>
              <Row justify={"center"}>
                <Col sm={22} md={10}>
                  {!cookies.cookieConsent && <CookieConsentView />}
                </Col>
              </Row>
            </Col>
          </Row>
        </Content>
        {isAuthenticated && (
        <Footer style={{ textAlign: "center" }}>
            <Row>
              <Col xs={6} style={{ textAlign: "left" }}>
                <Image
                  style={{ maxHeight: "70px" }}
                  xs={24}
                  md={6}
                  src={require("../assets/saasta-logo.png")}
                  alt="SEIMS: NYS, SAASTA Logo"
                />
              </Col>
              <Col xs={14} className="center-align">
                <p className="footer-text">SEIMS ©{currentYear} CSIR</p>
              </Col>
              <Col xs={4} className="right-align csir-logo">
                <div>
                  <Image
                    style={{ maxHeight: "50px" }}
                    src={require("../assets/csir-logo.png")}
                    alt="SEIMS: NYS, CSIR Logo"
                  />
                </div>
              </Col>
            </Row>
          </Footer>
        )}

      </Layout>
    </>
  );
};
